import { CheckGreen } from "src/assets";
import { Box, Stack } from "@mui/material";
import { ROUTES } from "src/consts/routes";
import { useTranslation } from "react-i18next";
import Text from "src/components/Displays/Text";
import officina from "src/fonts/officina.woff2";
import { useNavigate } from "react-router-dom";
import PrimaryButton from "src/components/Shared/PrimaryButton";

const AccessSuccess = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleSubmit = () => {
    navigate(ROUTES.YOUR_NAME);
  };

  return (
    <Stack gap={10}>
      <Stack alignItems={"start"}>
        <CheckGreen />
      </Stack>

      <Text
        text={t("page.selfOnboardingSuccess.pageTitle")}
        sx={(theme) => ({
          fontSize: "32px",
          fontWeight: "500",
          lineHeight: "40px",
          color: "#317D5B",
          fontFamily: "officina",
          "@font-face": {
            fontFamily: "officina",
            src: `url(${officina}) format("woff2")`,
          },
        })}
      />

      <Text
        text={t("page.selfOnboardingSuccess.pageSubTitle")}
        sx={(theme) => ({
          fontSize: "14px",
          fontWeight: "400",
          lineHeight: "20px",
          fontFamily: "Inter",
        })}
      />

      <Stack alignItems={"center"}>
        <Box>
          <PrimaryButton
            onClick={handleSubmit}
            text={t("page.selfOnboardingSuccess.nextButton")}
            sx={(theme) => ({
              fontSize: "16px",
              fontWeight: "600",
              color: theme.palette.mainFont.primary,
            })}
          />
        </Box>
      </Stack>
    </Stack>
  );
};

export default AccessSuccess;
